import { HStack, Link, StackProps, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router";

import { IcoEnvironmentDot } from "@/common/components/Icons";
import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { useEnvironmentColors } from "@/environment/hooks/useEnvironmentColors";
import { EnvironmentDTO } from "@reflag/shared/environmentAPI";
import { GlobalSettingsUrl } from "@reflag/shared/urls";

type Props = {
  environment: Pick<EnvironmentDTO, "name" | "isProduction">;
  link?: boolean;
  iconColor?: StackProps["color"];
} & StackProps;

export const EnvironmentDisplayName = ({
  environment,
  link = false,
  color,
  iconColor,
  ...stackProps
}: Props) => {
  const { env } = useEnvironment();
  const colors = useEnvironmentColors();
  const envColor =
    colors[environment.isProduction ? "production" : "nonProduction"];

  const component = (
    <HStack spacing={1} {...stackProps}>
      <IcoEnvironmentDot
        color={iconColor ? iconColor : envColor.icon}
        flexShrink={0}
        size="sm"
      />
      <Text
        as="span"
        color={color ? color : envColor.text}
        fontWeight="medium"
        isTruncated
      >
        {environment.name}
      </Text>
    </HStack>
  );

  if (link && env) {
    return (
      <Link
        as={RouterLink}
        style={{ textDecoration: "none" }}
        to={GlobalSettingsUrl(env, "app-environments")}
      >
        {component}
      </Link>
    );
  } else {
    return component;
  }
};
